import React, { useEffect, useMemo, useState } from "react";
import { Pagination } from "semantic-ui-react";
import MeHealthCreditUsageFilter from "./MeHealthCreditUsageFilter";
import MeHealthCreditUsageTable from "./MeHealthCreditUsageTable";
import {convertThaiDateToISO, formatDate, formatISOToThaiDate} from "react-lib/utils/dateUtils";
import moment from "moment";

const CREDIT_OPTIONS = [
  { key: "ALL", text: "All", value: "ALL" },
  { key: "ADD", text: "เพิ่มเครดิต", value: "ADD" },
  { key: "DEDUCT", text: "ลดเครดิต", value: "DEDUCT" },
];

const ROWS_PER_PAGE = 5;

type MeHealthCreditUsageTabProps = {
  BillingAndPackageSequence: any;
  BillingCreditWallet: any;
  runSequence: any;
  setProp: any;
  primaryColor: string;
  borderColor: string;
  onClose: () => void;
  closeButtonColor: string;
}

const MeHealthCreditUsageTab = (props: MeHealthCreditUsageTabProps) => {

  const today = moment();
  const back7days = moment().subtract(7,"day");
  
  
  const [searchDateFrom, setSearchDateFrom] = useState(formatDate(back7days));
  const [searchDateTo, setSearchDateTo] = useState(formatDate(today));
  const [filterCreditNo, setFilterCreditNo] = useState("");
  const [creditType, setCreditType] = useState("ALL");
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    handleSearch()
  }, [])

  const handleSearch = () => {
    setActivePage(1);

    props.runSequence({
      sequence: "BillingAndPackage",
      action: "GET_CREDIT_USAGE_LIST",
      credit_no: filterCreditNo,
      credit_use: creditType !== "ALL" ? creditType : "",
      credit_date_start: convertThaiDateToISO(searchDateFrom),
      credit_date_end: convertThaiDateToISO(searchDateTo),
    });
  }

  // const filteredData = useMemo(() => {
  //   return MOCK_USAGE.filter((item) => {
  //     const keywordMatch = keyword
  //       ? item.orderNo.toLowerCase().includes(keyword.toLowerCase())
  //       : true;
  //     const typeMatch = creditType === "ALL" ? true : item.type === creditType;
  //     // Date filter placeholder - no backend so always true
  //     return keywordMatch && typeMatch;
  //   });
  // }, [keyword, creditType]);

  const totalPages = Math.max(1, Math.ceil((props.BillingAndPackageSequence?.creditUsageList?.items || []).length / ROWS_PER_PAGE));
  const displayedRows = (props.BillingAndPackageSequence?.creditUsageList?.items || []).slice(
    (activePage - 1) * ROWS_PER_PAGE,
    activePage * ROWS_PER_PAGE
  );

  const creditUpdatedAt = props.BillingCreditWallet?.balance_updated_at;
  console.log('creditUpdatedAt: ', creditUpdatedAt);

  return (
    <div>
      <div
        style={{
          backgroundColor: "#fbd6e2",
          borderRadius: "10px",
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
          marginBottom: "16px",
        }}
      >
        <div>
          <div style={{ color: "#5d2d34" }}>คงเหลือ</div>
          <div style={{ color: "#8a4f58", fontSize: "14px" }}>{creditUpdatedAt ? `อัพเดทล่าสุด ${formatISOToThaiDate(creditUpdatedAt)}` : "" }</div>
        </div>
        <div style={{ fontSize: "24px", color: "#5d2d34" }}>{Number(props.BillingCreditWallet?.balance || "0.00").toLocaleString(undefined, { minimumFractionDigits: 2 }) ?? 0} Credit</div>
      </div>

      <MeHealthCreditUsageFilter
        keyword={filterCreditNo}
        onKeywordChange={setFilterCreditNo}
        creditType={creditType}
        onCreditTypeChange={(value) => setCreditType(String(value))}
        creditOptions={CREDIT_OPTIONS}
        dateFrom={searchDateFrom}
        onDateFromChange={setSearchDateFrom}
        dateTo={searchDateTo}
        onDateToChange={setSearchDateTo}
        onSearch={handleSearch}
        loading={props.BillingAndPackageSequence?.creditUsageLoading}
      />

      <MeHealthCreditUsageTable rows={displayedRows} />

      <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
        <Pagination
          totalPages={totalPages}
          activePage={activePage}
          onPageChange={(e, { activePage }) => setActivePage(Number(activePage))}
          ellipsisItem={{ content: "…", icon: true }}
        />
      </div>
    </div>
  );
};

export default MeHealthCreditUsageTab;
